import AddNew from 'Components/Atoms/ExpandableItems/AddNew';
import Grid from 'Components/Atoms/Grid/Grid';
import Title from 'Components/Atoms/Title/Title';
import EditButton from 'Components/Molecules/EditButton/EditButton';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { convertDateToYear } from 'Services/Date/Date';
import { createCandidateValues, saveCandidateValues } from 'Store/Candidate/Actions';
import { CandidateId } from 'Store/Candidate/PropTypes';
import { getCandidate, getCandidateValuesFromCandidateId } from 'Store/Candidate/Selectors';
import { CANDIDATE_PREDEFINED, FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import containerStyles from './../../Organisms/LayoutContainer/LayoutContainer.module.sass';
import styles from './Courses.module.sass';

const calculateTimeDifference = (date1: any, date2: any) => {
    date1 = new Date(date1);
    date2 = !date2 ? new Date() : new Date(date2);

    let output = '';
    let monthDiff = date2.getMonth() - date1.getMonth() + 12 * (date2.getFullYear() - date1.getFullYear());
    monthDiff += date2.getDate() > 15 ? 1 : 0;

    const years = Math.floor(monthDiff /  12);
    const months = monthDiff % 12;
    if (years > 0) {
        output += years + ' jaar';
    }

    if (years > 0 && months > 0) {
        output += ' en ';
    }

    if (months > 0) {
        output += months + (months == 1 ? ' maand' : ' maanden');
    }

    if (years <= 0 && months <= 0) {
        output = "0 maanden";
    }

    return output;
}

const Courses = ({ entity_id, candidate, values, ...props}: WorkExperiencesProps) => {
    const [state, setState] = useState({ isEdit: false });

    const [data, setData] = useState(values?.[CANDIDATE_PREDEFINED.COURSE]?.value || []);
    useEffect(() => {
        setData(values?.[CANDIDATE_PREDEFINED.COURSE]?.value || []);
    }, [values]);

    const emptyDataObject = {
        course: '',
        date: '',
    }

    const handleAddEducation = () => setData([...data, emptyDataObject]);

    const handleDeleteEducation = (idx: number) => {
        const tempData = [...data]?.filter((_, tempIdx: number) => tempIdx != idx);
        
        setData(tempData);
    }

    const handleCancel = () => setData(values?.[CANDIDATE_PREDEFINED.COURSE]?.value || []);

    const handleSave = () => {
        data.sort((a, b) => (a.date < b.date) ? 1 : -1);

        if (values?.[CANDIDATE_PREDEFINED.COURSE]?.value_id) {
            props.saveCandidateValues(entity_id, {[values?.[CANDIDATE_PREDEFINED.COURSE]?.value_id]: data});
        } else {
            props.createCandidateValues(entity_id, {[CANDIDATE_PREDEFINED.COURSE]: data});
        }

        setState((state) => ({
            ...state,
            isEdit: false
        }));
    };

    return <div className={containerStyles['layoutcontainer']} style={{width: '100%'}}>
        <Grid
            position='between'
            align='center'
            axis='horizontal'
        >
            <Title weight='semibold'>Cursussen</Title>
            
            <EditButton
                variant='button'
                isEdit={state.isEdit}
                onChange={(value) => setState({
                    ...state,
                    isEdit: value
                })}
                onSave={handleSave}
            />
        </Grid>

        { data.length == 0 &&
            <>
                { state.isEdit && <AddNew onClick={handleAddEducation}>+ Nieuwe cursus toevoegen</AddNew> }
                { !state.isEdit && <div>Geen resultaten...</div> }
            </>
        }

        <div className={styles['work_experience']}>
            <div className={styles['work_experience-list']}>
                
            {
                data.map((course: any, idx: number) => {
                    return <>
                        <div className={styles['work_experience-list-item']}>
                            {
                                !state.isEdit && <>
                                    <div className={styles['work_experience-list-item--side']}>
                                        { convertDateToYear(course?.date) } {
                                            course?.behaald &&
                                            <div style={{marginLeft: '4px'}}> - Behaald</div>
                                        }
                                    </div>
                                    <div className={styles['work_experience-list-item--content']}>
                                        <div className={styles['work_experience-list-item--content-title']}>
                                            { course?.course }
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                state.isEdit && <>
                                    <div className={styles['work_experience-list-item--side']}>
                                        <div className={styles['work_experience-list-item--side-date']}>
                                            <FormGroup title='Jaar'>
                                                <Field
                                                    type={FieldType.Date}
                                                    value={course?.date}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, date: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup title='Behaald'>
                                                <Field
                                                    type={FieldType.Toggle}
                                                    value={course?.behaald}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, behaald: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>

                                        { course.date && 
                                            <div className={styles['work_experience-list-item--side-computed']}>
                                                <strong>Datum: </strong> { convertDateToYear(course.date) }
                                            </div>
                                        }

                                        <div className={styles['delete']} onClick={() => handleDeleteEducation(idx)}>Cursus verwijderen</div>
                                    </div>
                                    <div className={styles['work_experience-list-item--content']}>
                                        <div className={styles['work_experience-list-item--content-title']}>
                                            <FormGroup title='Naam'>
                                                <Field
                                                    type={FieldType.Text}
                                                    value={course?.course}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index == idx) ? {...item, course: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        { state.isEdit && idx == data.length-1 && <AddNew onClick={handleAddEducation}>+ Nieuwe cursus toevoegen</AddNew> }
                    </>;
                })
            }
            </div>
        </div>
    </div>
}

interface Props {
    entity_id: CandidateId
}

const mapState = (state: StoreState, props: Props) => ({
    candidate: getCandidate(state, props.entity_id),
    values: getCandidateValuesFromCandidateId(state, props.entity_id)
});

const mapDispatch = {
    saveCandidateValues,
    createCandidateValues
};

type WorkExperiencesProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Courses);